<template>
  <div class="h5-container">
    <van-nav-bar
        class="top-bar"
        title="修改资料"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
    ></van-nav-bar>
    <div class="container-item">
      <van-form @submit="onSubmit">
        <div class="batch-item">
          <!-- 昵称 -->
          <van-field
              v-model="formData.nickName"
              name="nickName"
              label="昵称"
              placeholder="请输入昵称"
              :rules="[{ required: true, message: '请输入昵称' }]"
          />

          <!-- 电话 -->
          <van-field
              v-model="formData.userName"
              name="userName"
              label="电话"
              placeholder="请输入电话"
              :rules="[{ validator: telValidator, message: '请输入正确的11位手机号' }]"
          />

          <!-- 详细地址 -->
          <van-field
              v-model="formData.address"
              name="address"
              rows="1"
              autosize
              type="textarea"
              label="详细地址"
              placeholder="请输入您的详细地址"
          />

          <!-- 个性签名 -->
          <van-field
              v-model="formData.signature"
              name="signature"
              label="个性签名"
              placeholder="请输入个性签名"
          />

          <!-- 保存按钮 -->
          <div style="margin: 16px;">
            <van-button
                class="submit-btn"
                round
                block
                type="info"
                native-type="submit"
                :loading="isSubmitting"
            >保存</van-button>
          </div>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import '@/assets/css/mobileGlobal.scss';
import { Dialog, Toast } from "vant";
import { memberInformation, updateMemberInfo } from "@/api/mine"; // 补充修改资料接口

export default {
  data() {
    return {
      // 表单数据（仅保留需要的字段）
      formData: {
        id: "",
        nickName: "",    // 昵称
        userName: "",    // 电话
        address: "",     // 详细地址
        signature: ""    // 个性签名
      },
      originUserName: "", // 保存原始手机号（用于对比）
      isSubmitting: false // 防止重复提交
    };
  },
  created() {
    // 获取用户信息回显
    this.getUserInfo();
  },
  methods: {
    // 手机号验证规则（符合vant表单验证规范）
    telValidator(val) {
      if (!val) {
        return false; // 空值验证失败
      }
      const reg = /^1[3-9]\d{9}$/;
      return reg.test(val); // 正则验证通过返回true，否则false
    },

    // 保存修改（新增手机号修改确认逻辑）
    async onSubmit(values) {
      // 防止重复提交
      if (this.isSubmitting) return;

      // 1. 先判断手机号是否修改
      const newPhone = values.userName.trim();
      const isPhoneChanged = newPhone && newPhone !== this.originUserName;

      // 2. 手机号修改则弹出确认框
      if (isPhoneChanged) {
        try {
          await Dialog.confirm({
            title: "重要提示",
            message: `您即将修改手机号为${newPhone}，修改后原手机号将无法登录系统，是否确认修改？`,
            confirmButtonText: "确认修改",
            cancelButtonText: "取消"
          });
        } catch (error) {
          // 用户取消修改
          return;
        }
      }

      // 3. 确认后执行保存逻辑
      try {
        this.isSubmitting = true;

        // 组装提交数据（过滤空值）
        const submitData = {
          id: this.formData.id,
          nickName: values.nickName.trim(),
          userName: newPhone,
          address: values.address.trim(),
          signature: values.signature.trim()
        };

        // 调用修改资料接口
        const res = await updateMemberInfo(submitData);

        if (res.code === 200) {
          Toast(isPhoneChanged
              ? "资料修改成功，新手机号将作为登录账号"
              : "资料修改成功"
          );
          // 返回上一页
          setTimeout(() => {
            this.onClickLeft();
          }, 1000);
        } else {
          Toast(res.returnMsg || "资料修改失败");
        }
      } catch (error) {
        console.error("保存失败：", error);
        Dialog.alert({
          title: "错误",
          message: "网络异常，请稍后重试"
        });
      } finally {
        this.isSubmitting = false;
      }
    },

    // 获取用户信息回显（保存原始手机号）
    async getUserInfo() {
      try {
        const res = await memberInformation();
        if (res.code === 200 && res.data) {
          // 回显用户信息
          this.formData = {
            id: res.data.id || "",
            nickName: res.data.nickName || "",
            userName: res.data.userName || "",
            address: res.data.address || "",
            signature: res.data.signature || ""
          };
          // 保存原始手机号（用于后续对比）
          this.originUserName = res.data.userName || "";
        } else {
          Dialog.alert({ title: "提示", message: res.returnMsg });
        }
      } catch (err) {
        Dialog.alert({ title: "错误", message: "请稍后重试" });
      }
    },

    // 顶部标题栏返回事件
    onClickLeft() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped lang="scss">
::v-deep .van-icon-arrow-left {
  color: #0f0f0f !important;
}
::v-deep .van-nav-bar__text {
  color: #0f0f0f !important;
}
.van-radio--horizontal{
  margin-bottom: 10px;
}
.top-bar{
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
}
.container-item {
  margin-bottom: 60px;
}
.batch-item {
  padding: 10px;
  background: #f9f9f9;
  border-radius: 8px;
  margin: 15px;
}
.submit-btn{
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
  border: none;
}
</style>